"use strict";
const React = require('react');
const cloud_queue_1 = require('material-ui/svg-icons/file/cloud-queue');
const cloud_off_1 = require('material-ui/svg-icons/file/cloud-off');
const Flex_1 = require('./Flex');
const Navigation_1 = require('./Navigation');
const Screen_1 = require('./Screen');
class NoConnectionScreen extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            timeoutId: setTimeout(() => this.setState({ timeoutId: null }), 2500),
        };
    }
    componentWillUnmount() {
        window.clearTimeout(this.state.timeoutId);
    }
    render() {
        return (React.createElement(Screen_1.Screen, null, 
            React.createElement(Navigation_1.default, {title: "My Minutes"}), 
            React.createElement(Screen_1.ScreenContent, null, this.renderBody())));
    }
    renderBody() {
        if (this.state.timeoutId) {
            return (React.createElement(Flex_1.Column, {style: style.body}, 
                React.createElement(cloud_queue_1.default, {style: style.cloudIcon}), 
                React.createElement("h3", null, "Connecting...")));
        }
        else { }
        return (React.createElement(Flex_1.Column, {style: style.body}, 
            React.createElement(cloud_off_1.default, {style: style.cloudIcon}), 
            React.createElement("h3", null, "No Connection"), 
            React.createElement("p", null, "My Minutes needs an internet connection to start.")));
    }
}
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = NoConnectionScreen;
const style = {
    body: {
        alignItems: 'center',
        height: '100%',
        justifyContent: 'center',
    },
    cloudIcon: {
        height: 56,
        width: 56,
    }
};



/** WEBPACK FOOTER **
 ** ./src/components/NoConnectionScreen.tsx
 **/